import { CANONICAL_MAIN_DASHBOARD_MODULE_IDS, UserVersion } from "@framework/types";

interface IMainDashboardModuleMeta {
  id: string;
  labelMessageId: string;
  professionalOnly?: boolean;
}

export const MAIN_DASHBOARD_MODULES: readonly IMainDashboardModuleMeta[] = [
  { id: "1", labelMessageId: "pages.dashboard.scheme" },
  { id: "2", labelMessageId: "pages.dashboard.journals" },
  { id: "3", labelMessageId: "pages.dashboard.eventsLog" },
  { id: "4", labelMessageId: "pages.dashboard.analytics" },
  { id: "5", labelMessageId: "pages.dashboard.forecasting" },
  { id: "6", labelMessageId: "pages.dashboard.multiAnalysis", professionalOnly: true },
] as const;

export const MAIN_DASHBOARD_MODULE_IDS: readonly string[] = MAIN_DASHBOARD_MODULES.map(m => m.id);

if (MAIN_DASHBOARD_MODULE_IDS.join(",") !== CANONICAL_MAIN_DASHBOARD_MODULE_IDS.join(",")) {
  throw new Error(
    "MAIN_DASHBOARD_MODULE_IDS должен совпадать с CANONICAL_MAIN_DASHBOARD_MODULE_IDS из @framework/types.",
  );
}

export const MAIN_DASHBOARD_MODULE_LABEL_MESSAGE_IDS: Record<string, string> = Object.fromEntries(
  MAIN_DASHBOARD_MODULES.map(m => [m.id, m.labelMessageId]),
);

export const getMainDashboardModuleIdsForVersion = (version: UserVersion | string | null | undefined): string[] =>
  MAIN_DASHBOARD_MODULES.filter(module => !module.professionalOnly || version === UserVersion.PROFESSIONAL).map(
    module => module.id,
  );

export const filterMainDashboardModuleIdsForVersion = (
  moduleIds: readonly string[],
  version: UserVersion | string | null | undefined,
): string[] =>
  moduleIds.filter(moduleId => {
    const moduleMeta = MAIN_DASHBOARD_MODULES.find(module => module.id === moduleId);

    return !moduleMeta?.professionalOnly || version === UserVersion.PROFESSIONAL;
  });
